import type { IntlShape } from 'react-intl'

/** Appended to user-facing error messages for all error status codes. */
export const SUPPORT_MESSAGE =
  'Please double-check your entry and try again. If you continue to have trouble, contact our Client Services team at 774-229-4004 or support@inflectionmedicine.com'

export function withSupportMessage(intl: IntlShape, message: string): string {
  const suffix = intl.formatMessage({ id: 'errors.supportSuffix', defaultMessage: SUPPORT_MESSAGE })
  return `${message} ${suffix}`
}
